import React from 'react';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  return (
    <footer className="bg-black/80 border-t border-white/10 py-8 px-4 sm:px-8 text-center">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="max-w-4xl mx-auto"
      >
        <p className="text-white/60 text-sm uppercase tracking-wide">
          © 2026 Muhammed Sufiyan PK 
        </p>
      </motion.div>
    </footer>
  );
};

export default Footer;